<template>
    <div class="audio" @click.stop>
        <!-- 播放按钮 -->
        <div class="playerImg" style="width: 24px; height: 24px;">
            <i @click="player" ref="playBtn" class="play-player"></i>
            <audio ref="audio" id="audio" :src="newUrl"></audio>
        </div>
        <!--播放进度-->
        <div class="proBox">
            <div class="progrees">
                <div ref="progrees" class="curProgrees"></div>
            </div>
            <span ref="drag" class="drag"></span>
        </div>
        <!--播放时间-->
        <div class="playTime">
            <span ref="minTime" class="minTime">00</span>
            <span>:</span>
            <span ref="secTime" class="secTime">00</span>
        </div>
    </div>
</template>

<script>
import { myListener } from "../../util";
export default {
    props: {
        url: {
            type: [String],
            default: ""
        }
    },
    data() {
        return {
            newUrl: ""
        };
    },
    methods: {
        // 播放按钮
        player() {
            let { audio } = this.$refs;
            if (audio.paused) {
                audio.play();
            } else {
                audio.pause();
            }
        },
        // 进度条和圆型d长度
        progressWidth(audio, drag, progrees) {
            let speed = (100 / audio.duration) * audio.currentTime;
            drag.style.left = speed + "%";
            progrees.style.left = -(100 - speed) + "%";
        },
        // 播放时间
        getPlayerTime(audio, secTime, minTime, currentTime, flag = false) {
            let totalTime = null;
            if (flag) {
                totalTime = audio.duration - currentTime;
            } else {
                totalTime = audio.duration;
            }
            // 获取歌曲的分钟数和秒数
            let allSec = Math.floor(totalTime % 60);
            let allMin = Math.floor(totalTime / 60);
            //设置显示格式
            if (allSec < 10) {
                allSec = "0" + allSec;
            }
            if (allMin < 10) {
                allMin = "0" + allMin;
            }
            //拼接显示内容
            minTime.innerHTML = allMin;
            secTime.innerHTML = allSec;
        }
    },
    created() {
        this.newUrl = this.$props.url;
    },
    mounted() {
        let _this = this;
        let { audio, playBtn, progrees, drag, secTime, minTime } = this.$refs;
        this.listen = myListener(audio, "canplay", function() {
            _this.getPlayerTime(audio, secTime, minTime);
        });
        this.listen2 = myListener(audio, "timeupdate", function() {
            _this.progressWidth(audio, drag, progrees);
            _this.getPlayerTime(
                audio,
                secTime,
                minTime,
                audio.currentTime,
                true
            );
        });
        this.listen3 = myListener(audio, "play", function() {
            playBtn.className = "play-stop";
        });
        this.listen4 = myListener(audio, "pause", function() {
            playBtn.className = "play-player";
        });
    },
    destroyed() {
        this.listen();
        this.listen2();
        this.listen3();
        this.listen4();
    }
};
</script>

<style lang="less" scoped>
.audio {
    width: 100%;
    height: 52px;
    background: rgba(248, 248, 248, 1);
    border-radius: 2px;
    margin-top: 16px;
    padding: 14px 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
.play-player {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(../assets/img/icon-player.png) no-repeat center center;
    background-size: 100% 100%;
}
.play-stop {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(../assets/img/icon-stop.png) no-repeat center center;
    background-size: 100% 100%;
}
.progrees {
    width: 100%;
    height: 2px;
    background: #ccc;
    border-radius: 3px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
}
.curProgrees {
    width: 100%;
    top: 0;
    left: -100%;
    height: 100%;
    background: #ff4c67;
    position: absolute;
    border-radius: 3px;
}
.drag {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    box-shadow: 0px 0px 1px 1px #ccc;
}
.playTime {
    font-size: 12px;
    font-weight: 400;
    color: rgba(167, 167, 167, 1);
    line-height: 16px;
    margin-left: 5px;
}
.proBox {
    width: 210px;
    height: 100%;
    position: relative;
    margin: 0 14px 0 12px;
}
</style>
